
(function($) {
    
    $(document).ready(function(){

        $('.hero-slider').slick({
            slidesToShow:       1,
            slidesToScroll:     1,
            fade:               true,
            speed:              1000,
            arrows:             false,
            dots:               true,
            infinite:           true,
            adaptiveHeight:     false,
            autoplay:           true,
            autoplaySpeed:      4000,
        });

    });
    

}(jQuery));